import React, {Component} from 'react';
import {browserHistory, Link} from "react-router";
import {
    PATH_BUSCADOR_ANIMALES_ADMIN_ANIMAL_ID,
    PATH_BUSCADOR_PETFRIENDLY_DETAIL_PERMALINK_PATTERN,
} from "../../../../App/RouterAdopta";

import ClassNames from 'classnames';
import {MAP_SUBTIPOS_ENTITY_CONFIG} from '../../../../config/globalFrontEndConfig.js'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {normalizeName} from '../../../../Utils/Analizer.js'
import {LazyLoadImage} from "react-lazy-load-image-component";


class CardEntityListing extends Component {
    
    constructor(props) {
        super(props);
        
        // this.props.isLogin();
        
        this.state = {
            img: undefined,
        }
        this.configEstadoContacto = {
            id: "",
            collSize: "divSelectContactoAnimal",
            seleccionado: "",
            placeHolder: "Estados",
            data: ["¿Quieres saber más?"],
            messageWhatsapp: "Hola!%20Quiero%20m%C3%A1s%20informaci%C3%B3n%20de%20",
            idSelect: "contactoAnimal",
            divSelect: ".divSelectContactoAnimal",
            tipo: 'animal'
        };
        
        //Config información
        this.configInformation = {
            titleHead: "Compartir",
            
            socials: [
                {
                    url: "",
                    socialIcon: "lab la-facebook-f"
                },
                {
                    url: "",
                    socialIcon: "lab la-twitter"
                },
                {
                    url: "",
                    socialIcon: "lab la-instagram"
                }
            ]
        };
        
        
        this.handleModify = this.handleModify.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleImageLoaded = this.handleImageLoaded.bind(this);
        this.handleImageError = this.handleImageError.bind(this);
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
        this.onClickCard = this.onClickCard.bind(this);
    }
    
    handleModify(idAnimal) {
        browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_ANIMAL_ID + idAnimal);
    }
    
    
    handleDelete() {
        this.props.removing(true, this.props.animalsControl);
        this.props.changeWaitBlock(true);
    }
    
    capitalizeString(tkn) {
        if (tkn != undefined) {
            const REG_EXP_SEPARADORES = new RegExp(/[-.–\-,\/():“”"’'’#!?¿¡"@`^&]/, "gi")
            
            tkn = tkn.toLowerCase()
            let primeraLetra
            if (REG_EXP_SEPARADORES.test(tkn.slice(0, 1))) {
                primeraLetra = tkn.slice(0, 1) + tkn.slice(1, 2).toUpperCase()
                tkn = primeraLetra + tkn.slice(2, tkn.length)
            } else {
                primeraLetra = tkn.slice(0, 1).toUpperCase()
                tkn = primeraLetra + tkn.slice(1, tkn.length)
            }
        }
        
        return tkn;
    }
    
    onMouseEnter(event) {
        // console.log("CardEntityListing::onMouseEnter()");
        if (this.props.onMouseOverElement) {
            this.props.onMouseOverElement(this.props.entity._id)
        }
    }
    
    onMouseLeave(event) {
        // console.log("CardEntityListing::onMouseLeave()");
        if (this.props.onMouseOverElement) {
            this.props.onMouseOverElement(undefined)
        }
    }
    
    onClickCard(e) {
        //console.log("CardEntityListing::onClickCardListing()");
        const idClick = e.currentTarget?.dataset?.id
        const index = e.currentTarget?.dataset?.index
        //console.log("idClick = '" + idClick + "'");
        //console.log("index = '" + index + "'");

        this.props.onClickCard(idClick,index)
    }
    
    render() {
        let direccion;
        
        
        let classReady = "";
        let isReady = this.props.isReady;
        if (isReady) {
            classReady = "listing-entities__item-image";
        } else {
            //Caso en que estén cacheadas...
            if (this.props.imagesLoaded === 0) {
                classReady = "listing-entities__item-image";
                isReady = true;
            } else {
                classReady = "listing-entities__item-image image_holder";
            }
        }
        
        let srcImage = this.props.entity.img_principal && this.props.entity.img_principal.url
            ? this.props.entity.img_principal.url
            : `${process.env.CDN_URL}/images/adoptaunanimal/default/${this.props.entity.tipo.toLowerCase()}2.png`
        // : getImageEncode("default." + "protectora")
        
        // let razas = this.props.entity.raza.join(', ').replace(/,(?!.*,)/gmi, ' y')
        // let nombre = this.capitalizeString(this.props.entity.nombre)
        let nombre = this.props.entity.nombre
        let tipo = (this.props.entity && this.props.entity.subtipo) ? this.props.entity.subtipo : this.props.entity.tipo
        const icon = MAP_SUBTIPOS_ENTITY_CONFIG[normalizeName(this.props.entity.tipo)][normalizeName(this.props.entity.subtipo)].faIcon
        const colorIcon = MAP_SUBTIPOS_ENTITY_CONFIG[normalizeName(this.props.entity.tipo)][normalizeName(this.props.entity.subtipo)].colorIcon
        let localizacion = (this.props.entity.direccion.municipio) ? this.props.entity.direccion.municipio + ", " + this.props.entity.direccion.provincia : (this.props.entity.direccion.region) ? this.props.entity.direccion.region : this.props.entity.direccion.provincia
        const pathLink = PATH_BUSCADOR_PETFRIENDLY_DETAIL_PERMALINK_PATTERN
            .replace(":tipo_entity", this.props.entity.tipo)
            .replace(":permalink", this.props.entity.permalink) + "?utm_source=buscador&utm_medium="+(this.props.isRecomendationCards?"recomendation":"listing")
        
        return (
            <Link className={"listing-entities__item-a"} target={(this.props.isRecomendationCards) ? "" : "_blank"}
                  to={pathLink}
                  onlyActiveOnIndex>
                <div id={"card-" + this.props.entity._id}
                     key={"card-" + this.props.entity._id}
                     className={ClassNames("listing-entities__item", (this.props.isRecomendationCards) ? "listing-entities__item-vertical" : "",
                         {"listing-entities__item--selected": this.props.index === this.props.indexSelected},
                         {"listing-entities__item-hover": this.props.currentElementHoverId === this.props.entity._id})}
                    //onClick={this.props.onClickCardListing}
                     onMouseEnter={this.onMouseEnter}
                     onMouseLeave={this.onMouseLeave}
                     onClick={this.onClickCard}
                     data-index={this.props.index}
                     data-indexrow={Math.trunc(this.props.index / this.props.elementsPerRow)}
                     data-id={this.props.entity._id}
                     data-entity_type={this.props.entity.tipo}
                >
                    <div className={classReady + " img-hover-zoom"}>
                        <LazyLoadImage
                            id={"img-animal-" + this.props.entity._id}
                            key={this.props.entity._id}
                            style={isReady ? {} : {display: 'none'}}
                            className="img-fluid"
                            alt={`image-${nombre}`}
                            src={srcImage}
                            width={398}
                            height={298}
                            threshold={150}
                            onLoad={this.handleImageLoaded.bind(this, this.props.index)}
                            onError={this.handleImageError}
                            //onClick={this.props.onClickCardListing}
                            data-indexrow={Math.trunc(this.props.index / this.props.elementsPerRow)}
                            data-id={this.props.entity._id}
                        />
                    </div>
                    
                    {isReady &&
                        <div className="listing-entities__item-info">
                            <div>
                                <div className="listing-entities__item-title">
                                    <h2
                                        className="listing-entities__item-title"> {/*(this.props.index + 1) + " - " +*/ nombre} </h2>
                                </div>
                                <div className="listing-entities__item-subtitle">
                                    <h3 className="listing-entities__item-subtitle-current"><span
                                        className={"custom-control-description"}>
                            {icon && <FontAwesomeIcon icon={icon} color={colorIcon}/>}
                                        {" " + tipo}</span></h3>
                                </div>
                                <div className="listing-entities__item-extra">
                                    <i className="las la-lg la-map-marker-alt"/>
                                    <span className="listing-entities__item-extra-text">{localizacion}</span>
                                </div>
                            </div>
                            
                            {/*<a onClick={this.props.onClickCardListing} data-index={this.props.index}*/}
                            {/*   data-indexrow={Math.trunc(this.props.index / this.props.elementsPerRow)}*/}
                            {/*   data-id={this.props.entity._id}*/}
                            {/*   href="#"*/}
                            {/*   className="btn btn-outline-primary btn-card-animal">Ver protectora</a>*/}
                            {/**/}
                            <span className="btn btn-outline-primary btn-card-animal">Ver {tipo}</span>
                        </div>
                    }
                </div>
            </Link>
        );
    }
    
    handleImageLoaded(index, idImage) {
        if (this.props.imageLoaded) this.props.imageLoaded(this.props.animalsControl);
    }
    
    handleImageError() {
        //console.log("CardEntityListing::handleImageError()");
        // this.props.imageError(this.props.animalsControl);
    }
    
    
    componentWillMount() {
    
    
    }
    
    componentDidMount() {
    
    }
    
}

export default CardEntityListing